const festiveRevealSelector = [
  '.festive-media-showcase',
  '.festive-feature-grid',
  '.festive-story',
  '.festive-gallery',
  '.festive-comparison',
  '.festive-reviews-placeholder',
  '.festive-faq',
  '.festive-cta'
].join(',');

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const revealSections = (scope = document) => {
  const sections = scope.querySelectorAll(festiveRevealSelector);

  if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  sections.forEach((section) => {
    if (section.classList.contains('festive-section-reveal')) return;
    section.classList.add('festive-section-reveal');
    observer.observe(section);
  });
};

const updateHeaderState = () => {
  document.body.classList.toggle('festive-page-scrolled', window.scrollY > 24);
};

revealSections();
updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });
document.addEventListener('shopify:section:load', (event) => revealSections(event.target));
